import { Component, OnInit, Input, Output, EventEmitter, ElementRef, ViewChild } from '@angular/core';
import { IFileUploadDialog } from '../../interface/IFileUploadDialog';
import { LogService, ConfigJsonService, IFileUploadResponse } from '@medlogic/shared/shared-interfaces';
import { UnsubscribeOnDestroyAdapter } from '@medlogic/shared/shared-interfaces';
import { EnFileUploadMode } from '../../enum/EnFileUploadMode';
import { IDocumento } from '@medlogic/shared/shared-interfaces';
import { error } from '../../service/error';
import { FileUploadService } from '../../service/file-upload.service';
import { tap } from 'rxjs/operators';
import { GlobalService } from '@medlogic/shared/shared-interfaces';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DialogConfirmComponent } from '@medlogic/shared/ui/dialog/ui-dialog-confirm';
import { MatDialog } from '@angular/material/dialog';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'lib-cmp-file-upload-selector',
  templateUrl: './cmp-file-upload-selector.component.html',
  styleUrls: ['./cmp-file-upload-selector.component.css']
})
export class CmpFileUploadSelectorComponent extends UnsubscribeOnDestroyAdapter implements OnInit {

  @Input() enFileUploadMode: EnFileUploadMode;
  @Input() data: IFileUploadDialog;
  @Input() show: Boolean = true;
  @Input() acceptFiles = '.pdf, .xlsx, .xls, image/*, .doc, .docx, .ppt, .pptx, .pps, .ppsx, .txt, .xml, .zip, .rar';

  @Output() afterFileUpload = new EventEmitter<IDocumento>();
  @Output() afterOpenWebcam = new EventEmitter<boolean>();
  @Output() afterChooseFile = new EventEmitter<boolean>();

  @ViewChild('fileNameInput') fileNameInput!: ElementRef<HTMLInputElement>;

  selectedDocument: IDocumento;
  fileToUpload: File = null;
  isLoading = false;
  progress: number;
  backgroundColor = 'transparent';
  filenameControl: FormControl = new FormControl();

  constructor(
    private cnfJson: ConfigJsonService,
    private log: LogService,
    private glb: GlobalService,
    private fileUploadSrv: FileUploadService,
    private snackBar: MatSnackBar,
    private matDialog: MatDialog,
  ) {
    super();
  }

  fileEvent: any;
  preview: any;
  fileName: string;
  fileType: string;
  rotation: number;

  ngOnInit() {
    this.preview = null;
    this.rotation = 0;
  }

  cleanInputFile($event: any): void {
    const input = $event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      input.value = '';
    }
  }

  onImgChange(event: any): void {
    const file = event.target.files[0];
    this.fileName = file.name;
    this.fileType = '.' + file.name.split('.').pop().toLowerCase();

    if (file.type.includes('image')) {
      if (!(this.fileName.endsWith('.png') || this.fileName.endsWith('.jpg') || this.fileName.endsWith('.jpeg'))) {
        this.snackBar.open('Formatos de imagens permitidos: .png, .jpg, .jpeg.', 'OK', {
          duration: 5000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: 'warning-snackbar'
        });

        this.cleanInputFile(event);
        this.onPreviewBack(event);

        return;
      }

      this.fileType = '.png';
      this.fileEvent = event;
      this.filenameControl = new FormControl(this.fileName, [
        Validators.required,
        Validators.pattern(/^[A-Za-z0-9\-_.() ]+$/)
      ]);
    } else {
      this.enFileUploadMode = EnFileUploadMode.list;

      const width = '100%';
      const height = '100%';
      const title = 'Deseja renomear o arquivo?';
      const label = 'Digite o nome do arquivo';
      const dialog = this.matDialog.open(DialogConfirmComponent, {
        maxWidth: '560px',
        minWidth: '480px',
        maxHeight: '270px',
        width,
        height,
        data: {
          title,
          input: {
            value: this.fileName || file.name,
            label,
            type: 'text',
            pattern: '^[A-Za-z0-9\-_.() ]+$',
            placeholder: 'Digite o nome do arquivo',
            title: 'Use apenas letras, números, espaço, -, _, (, )',
          }
        }
      });

      dialog.afterClosed().subscribe((result: any) => {
        if (result.wasConfirmed) {
          this.fileName = result.input.value;
          this.fileToUpload = file;
          this.uploadFile(event);
        } else {
          this.onPreviewBack(event);
        }
      });
    }

    setTimeout(() => {
      if (this.fileNameInput) {
        this.fileNameInput.nativeElement.focus();
      }

      const input = event.target as HTMLInputElement;

      if (input.files && input.files.length > 0) {
        // input.value = '';
      }

      this.afterChooseFile.emit(false);
    }, 100);
  }

  imageCrop(event: ImageCroppedEvent) {
    this.preview = event.base64;
  }

  showCropper() { }
  invokeCropper() { }
  error() { }

  base64ToBlob(base64: string, type: string): Blob {
    const byteCharacters = atob(base64.split(',')[1]);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    return new Blob([byteArray], { type: type });
  }

  private getFileName(): string {
    if (this.fileName.includes('.')) {
      const idx = this.fileName.lastIndexOf('.');
      this.fileName = this.fileName.substr(0, idx);
    }

    const extensao = this.fileType || '.png';
    return this.fileName + extensao;
  }

  private isFileNameValid(): boolean {
    const regex = /^[A-Za-z0-9\-_.() ]+$/;
    return regex.test(this.fileName);
  }

  onUploadClick(): void {
    if (this.filenameControl.invalid) {
      this.filenameControl.markAsTouched();
      this.snackBar.open('Preencha o nome do arquivo corretamente', 'OK', {
        duration: 3000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
         panelClass: 'warning-snackbar'
      });

      return;
    }

    this.fileName = this.filenameControl.value

    this.uploadFile(null);
  }

  uploadFile($event: any): void {
    try {
      if (this.glb.IsNullOrEmpty(this.fileName)) {
        this.snackBar.open('Insira um nome para o arquivo', 'Ok', {
          duration: 3000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: 'warning-snackbar'
        });

        this.cleanInputFile($event);
        this.onPreviewBack($event);

        return;
      }

      if (!this.isFileNameValid()) {
        this.snackBar.open('Caracteres inválidos. Use apenas letras e números', 'Ok', {
          duration: 3000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: 'warning-snackbar'
        });

        this.cleanInputFile($event);
        this.onPreviewBack($event);

        return;
      }

      if (this.preview) {
        const blob = this.base64ToBlob(this.preview, 'image/png');
        const fileToUpload = new File([blob], this.getFileName(), { type: blob.type, lastModified: Date.now() });

        this.fileToUpload = fileToUpload;
      } else {
        this.fileToUpload = new File([this.fileToUpload], this.getFileName(), {
          type: this.fileToUpload.type,
          lastModified: this.fileToUpload.lastModified,
        });
      }

      if (this.fileToUpload) {
        this.uploadFileToActivity(this.fileToUpload, this.data);
      }
    } catch (error) {
      this.log.Registrar(this.constructor.name, 'uploadFile', error.message);
    }
  }

  uploadFileFromWebcam($event: any): void {
    try {
      const fileName = $event.fileName;
      this.fileName = fileName;
      this.enFileUploadMode = this.data.enFileUploadMode;

      const fileToUpload = new File([$event.imageData], fileName, { type: 'image/png' });
      this.fileToUpload = fileToUpload;

      this.onImgChange({ target: { files: [fileToUpload] } });

    } catch (error) {
      this.log.Registrar(this.constructor.name, 'uploadFileFromWebcam', error.message);
    }
  }

  onWebcamClick($event: any): void {
    try {
      this.fileToUpload = null;
      this.enFileUploadMode = EnFileUploadMode.webcam;

      this.afterOpenWebcam.emit(false);
    } catch (error) {
      this.log.Registrar(this.constructor.name, 'onWebcam', error.message);
    }
  }

  onPreviewBack($event: any): void {
    try {
      this.resetAll();
      this.afterChooseFile.emit(true);
    } catch (error) {
      this.log.Registrar(this.constructor.name, 'onPreviewBack', error.message);
    }
  }

  uploadFileToActivity($event: any, data: IFileUploadDialog): void {
    try {
      this.isLoading = true;

      const containerTag = `${this.cnfJson.project.toLowerCase()}`;
      const saveFileToStorage$ = this.fileUploadSrv.postFile(this.fileToUpload, data.ano, data.ono, data.vno, containerTag);

      this.subs.sink = saveFileToStorage$
        .pipe(
          this.finalizeAccordingFileUploadMode$(data.enFileUploadMode),
          error()
        ).subscribe();
    } catch (error) {
      this.log.Registrar(this.constructor.name, 'uploadFileToActivity', error.message);
    }
  }

  private finalizeAccordingFileUploadMode$ = (enFileUploadMode: EnFileUploadMode) =>
    tap((res: IFileUploadResponse) => {
      this.isLoading = false;

      this.resetAll();
      this.afterFileUpload.emit(res?.documento);
    })

  private resetAll() {
    this.fileToUpload = null;
    this.fileEvent = null;
    this.preview = null;
    this.enFileUploadMode = EnFileUploadMode.list;
    this.selectedDocument = null;
    this.progress = 0;
    this.fileName = null;
    this.fileType = null;
    this.rotation = 0;
  }

  rotateRight() {
    this.rotation++;
  }

  rotateLeft() {
    this.rotation--;
  }
}
